import React, { useRef } from "react";

import { NodeViewWrapper } from "@tiptap/react";

function getMediaWidth(width) {
    return width || "100%";
}

function getMediaAlign(align) {
    if (align === "left") return { marginLeft: 0, marginRight: "auto" };
    if (align === "right") return { marginLeft: "auto", marginRight: 0 };
    return { marginLeft: "auto", marginRight: "auto" };
}

function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}

function NoteMediaNodeView({ node, selected, type, updateAttributes }) {
    const wrapperRef = useRef(null);
    const attrs = node.attrs || {};
    const width = getMediaWidth(attrs.width);
    const alignStyle = getMediaAlign(attrs.align);

    const startResize = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const wrapper = wrapperRef.current;
        const container = wrapper?.closest?.(".note-editor");
        if (!wrapper || !container) return;

        const startX = event.clientX;
        const startWidth = wrapper.getBoundingClientRect().width;
        const containerWidth = container.getBoundingClientRect().width;
        const minWidth = Math.min(160, containerWidth);

        const handleMouseMove = (moveEvent) => {
            const nextWidthPx = clamp(startWidth + moveEvent.clientX - startX, minWidth, containerWidth);
            const nextWidthPercent = Math.round((nextWidthPx / containerWidth) * 100);
            updateAttributes({ width: `${nextWidthPercent}%` });
        };

        const handleMouseUp = () => {
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
        };

        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
    };

    return (
        <NodeViewWrapper
            ref={wrapperRef}
            as="figure"
            className={`note-media-node${selected ? " is-selected" : ""}`}
            contentEditable={false}
            draggable="true"
            data-drag-handle
            data-note-media-type={type}
            style={{
                width,
                maxWidth: "100%",
                ...alignStyle,
            }}
        >
            {type === "image" ? (
                <img data-note-image="true" src={attrs.src || ""} alt={attrs.alt || ""} draggable="false" />
            ) : (
                <video
                    data-note-video="true"
                    src={attrs.src || ""}
                    poster={attrs.poster || undefined}
                    controls
                    draggable="false"
                />
            )}
            {selected ? (
                <button
                    type="button"
                    className="note-media-resize-handle"
                    aria-label="미디어 크기 조절"
                    onMouseDown={startResize}
                />
            ) : null}
        </NodeViewWrapper>
    );
}

export default NoteMediaNodeView;
